// Modules 14-100 API client. axiosClient.baseURL = "/api/v1".
import api from './axiosClient';

const clean = (o = {}) =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => v !== '' && v !== null && v !== undefined));
const d = (p) => p.then((r) => r.data);

// ── insights (generic analytics) ──
export const getInsightCatalog = () => d(api.get('/insights'));
export const runInsight = (key, params) => d(api.get(`/insights/${key}`, { params: clean(params) }));
export const insightCsvUrl = (key) => `/insights/${key}/csv`;
export const downloadInsightCsv = async (key, params) => {
  const res = await api.get(`/insights/${key}/csv`, { params: clean(params), responseType: 'blob' });
  saveBlob(res.data, `${key}.csv`);
};
export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
export const openHtml = async (path) => {
  const res = await api.get(path, { responseType: 'text', transformResponse: (x) => x });
  const w = window.open('', '_blank');
  if (w) { w.document.open(); w.document.write(res.data); w.document.close(); }
};

// ── notifications (M15-M18) ──
export const notifMeta = () => d(api.get('/notifications/meta'));
export const listChannels = () => d(api.get('/notifications/channels'));
export const createChannel = (b) => d(api.post('/notifications/channels', b));
export const updateChannel = (id, b) => d(api.put(`/notifications/channels/${id}`, b));
export const deleteChannel = (id) => api.delete(`/notifications/channels/${id}`);
export const testChannel = (id) => d(api.post(`/notifications/channels/${id}/test`));
export const getNotifPrefs = () => d(api.get('/notifications/preferences'));
export const saveNotifPrefs = (b) => d(api.put('/notifications/preferences', b));
export const notifLog = () => d(api.get('/notifications/log'));

// ── incidents, evidence, appeal (M44-M46) ──
export const listIncidents = (status) => d(api.get('/incidents', { params: clean({ status }) }));
export const getIncident = (id) => d(api.get(`/incidents/${id}`));
export const createIncident = (b) => d(api.post('/incidents', b));
export const updateIncident = (id, b) => d(api.put(`/incidents/${id}`, b));
export const deleteIncident = (id) => api.delete(`/incidents/${id}`);
export const addIncidentNote = (id, b) => d(api.post(`/incidents/${id}/notes`, b));
export const listEvidence = () => d(api.get('/incidents/evidence'));
export const createEvidence = (b) => d(api.post('/incidents/evidence', b));
export const deleteEvidence = (id) => api.delete(`/incidents/evidence/${id}`);
export const appealTemplate = (params) => d(api.get('/incidents/appeal-template', { params: clean(params) }));

// ── analytics definitions (M57, M60) ──
export const listGoals = () => d(api.get('/analytics-defs/goals'));
export const saveGoal = (id, b) => d(id ? api.put(`/analytics-defs/goals/${id}`, b) : api.post('/analytics-defs/goals', b));
export const deleteGoal = (id) => api.delete(`/analytics-defs/goals/${id}`);
export const listFunnels = () => d(api.get('/analytics-defs/funnels'));
export const saveFunnel = (id, b) => d(id ? api.put(`/analytics-defs/funnels/${id}`, b) : api.post('/analytics-defs/funnels', b));
export const deleteFunnel = (id) => api.delete(`/analytics-defs/funnels/${id}`);
export const listSegments = () => d(api.get('/analytics-defs/segments'));
export const createSegment = (b) => d(api.post('/analytics-defs/segments', b));
export const deleteSegment = (id) => api.delete(`/analytics-defs/segments/${id}`);

// ── AdSense (M63, M69) ──
export const adsenseStatus = () => d(api.get('/adsense/status'));
export const adsenseConnectUrl = () => d(api.get('/adsense/connect-url'));
export const adsenseSync = (days) => d(api.post('/adsense/sync', null, { params: { days } }));
export const adsenseDisconnect = () => api.delete('/adsense/connection');
export const adsenseImport = (csv) => d(api.post('/adsense/import', { csv }));
export const adsenseManual = (b) => d(api.post('/adsense/manual', b));
export const adsenseClear = (source) => api.delete('/adsense/data', { params: clean({ source }) });
export const adsenseScan = (url) => d(api.post('/adsense/scan', { url }));
export const adsenseScans = () => d(api.get('/adsense/scans'));

// ── reports, schedules, shares, dashboards (M80-M85) ──
export const reportTemplates = () => d(api.get('/reports/templates'));
export const reportSections = () => d(api.get('/reports/sections'));
export const listReports = () => d(api.get('/reports'));
export const saveReport = (id, b) => d(id ? api.put(`/reports/${id}`, b) : api.post('/reports', b));
export const deleteReport = (id) => api.delete(`/reports/${id}`);
export const runReport = (id) => d(api.post(`/reports/${id}/run`));
export const listRuns = () => d(api.get('/reports/runs'));
export const deleteRun = (id) => api.delete(`/reports/runs/${id}`);
export const listSchedules = () => d(api.get('/reports/schedules'));
export const saveSchedule = (id, b) => d(id ? api.put(`/reports/schedules/${id}`, b) : api.post('/reports/schedules', b));
export const deleteSchedule = (id) => api.delete(`/reports/schedules/${id}`);
export const listShares = () => d(api.get('/reports/shares'));
export const shareRun = (id, expireDays) => d(api.post(`/reports/runs/${id}/share`, null, { params: clean({ expireDays }) }));
export const revokeShare = (id) => d(api.post(`/reports/shares/${id}/revoke`));
export const listDashboards = () => d(api.get('/reports/dashboards'));
export const saveDashboard = (id, b) => d(id ? api.put(`/reports/dashboards/${id}`, b) : api.post('/reports/dashboards', b));
export const deleteDashboard = (id) => api.delete(`/reports/dashboards/${id}`);

// ── collaboration (M96, M97) ──
export const listTasks = (status) => d(api.get('/collab/tasks', { params: clean({ status }) }));
export const saveTask = (id, b) => d(id ? api.put(`/collab/tasks/${id}`, b) : api.post('/collab/tasks', b));
export const deleteTask = (id) => api.delete(`/collab/tasks/${id}`);
export const listComments = (entityType, entityId) => d(api.get('/collab/comments', { params: { entityType, entityId } }));
export const addComment = (b) => d(api.post('/collab/comments', b));
export const deleteComment = (id) => api.delete(`/collab/comments/${id}`);
export const listTickets = () => d(api.get('/collab/tickets'));
export const getTicket = (id) => d(api.get(`/collab/tickets/${id}`));
export const createTicket = (b) => d(api.post('/collab/tickets', b));
export const replyTicket = (id, b) => d(api.post(`/collab/tickets/${id}/reply`, b));

// ── platform ──
export const listAudit = (params) => d(api.get('/audit', { params: clean(params) }));
export const auditCsv = async (params) => {
  const res = await api.get('/audit/csv', { params: clean(params), responseType: 'blob' });
  saveBlob(res.data, 'audit-log.csv');
};
export const twoFaStatus = () => d(api.get('/account/2fa'));
export const twoFaSetup = () => d(api.post('/account/2fa/setup'));
export const twoFaEnable = (code) => d(api.post('/account/2fa/enable', { code }));
export const twoFaDisable = (code) => api.post('/account/2fa/disable', { code });
export const getPrefs = () => d(api.get('/account/preferences'));
export const savePrefs = (b) => d(api.put('/account/preferences', b));
export const listApiKeys = () => d(api.get('/api-keys'));
export const createApiKey = (b) => d(api.post('/api-keys', b));
export const revokeApiKey = (id) => api.post(`/api-keys/${id}/revoke`);
export const listWebhooks = () => d(api.get('/webhooks'));
export const saveWebhook = (id, b) => d(id ? api.put(`/webhooks/${id}`, b) : api.post('/webhooks', b));
export const deleteWebhook = (id) => api.delete(`/webhooks/${id}`);
export const testWebhook = (id) => d(api.post(`/webhooks/${id}/test`));
export const webhookDeliveries = (id) => d(api.get(`/webhooks/${id}/deliveries`));
export const getRetention = () => d(api.get('/admin/retention'));
export const saveRetention = (b) => d(api.put('/admin/retention', b));
export const runRetention = () => d(api.post('/admin/retention/run'));
export const listPlans = () => d(api.get('/plans'));
export const myPlan = () => d(api.get('/plans/mine'));
export const savePlan = (id, b) => d(id ? api.put(`/plans/${id}`, b) : api.post('/plans', b));
export const assignPlan = (b) => d(api.post('/plans/assign', b));
export const privacyExport = async (b) => {
  const res = await api.post('/privacy/export', b, { responseType: 'blob' });
  saveBlob(res.data, 'subject-data.json');
};
export const privacyDelete = (b) => d(api.post('/privacy/delete', b));
export const privacyRequests = () => d(api.get('/privacy/requests'));
export const trainModel = (b) => d(api.post('/ml/train', b));
export const listModels = () => d(api.get('/ml/models'));
export const setModelStatus = (id, status) => d(api.post(`/ml/models/${id}/status`, null, { params: { status } }));
export const runDiagnostics = () => d(api.get('/diagnostics'));
